import React, { useState } from 'react';
import './inputGeneral.scss';
import Tooltip from '../../tooltip/Tooltip';
import { InputGeneralProps } from './inputGeneral.interface';

export default function InputGeneral({
    nameClass,
    value = '',
    type,
    name,
    isTypeChange,
    typeChange,
    placeholder,
    icon,
    iconTooltip,
    nameTooltip,
    positionTooltip,
    onChange,
    onFocus,
    onChangeArea,
    onFocusArea,
    errorMessage,
}: InputGeneralProps) {

    const [isFocused, setIsFocused] = useState<boolean>(false);

    const handleInputFocus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setIsFocused(true);
        if (type === 'textarea' && onFocusArea) onFocusArea(e as React.FocusEvent<HTMLTextAreaElement>);
        else if (onFocus) onFocus(e as React.FocusEvent<HTMLInputElement>);
    };

    const handleInputBlur = () => {
        setIsFocused(false);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (type === 'textarea' && onChangeArea) onChangeArea(e as React.ChangeEvent<HTMLTextAreaElement>);
        else if (onChange) onChange(e as React.ChangeEvent<HTMLInputElement>);
    };

    return (
        <div className='content_input'>
            <label className={`label ${isFocused ? 'active' : value ? 'selected' : ''} ${type === 'textarea' ? 'area' : ''}`}>{placeholder}</label>
            <div className='input_content'>
                {type === 'textarea' ? (
                    <textarea
                        className={`${nameClass} ${iconTooltip || icon ? 'icon_input' : ''}`}
                        placeholder={isFocused ? '' : placeholder}
                        value={value}
                        onChange={handleChange}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        name={name}
                    ></textarea>
                ) : (
                    <input
                        name={name}
                        type={isTypeChange ? typeChange : type}
                        value={value}
                        onChange={handleChange}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        placeholder={isFocused ? '' : placeholder}
                        className={`${nameClass} ${iconTooltip || icon ? 'icon_input' : ''}`}
                    />
                )}

                {errorMessage && <span className='error_message'>{errorMessage}</span>}
            </div>
            {iconTooltip && (
                <Tooltip text={nameTooltip} position={positionTooltip}>
                    <div className='info_button'>
                        <i className={iconTooltip}></i>
                    </div>
                </Tooltip>
            )}
            {icon && <i className={`icon ${icon}`}></i>}
        </div>
    );
}
